<template>
  <div class="expert-new">
    <Row :gutter="16">
      <i-col span="12">
        <Form ref="newForm" :model="expertModel"
          :rules="modelValidate"
          label-position="left"
          :label-width="140">
          <FormItem label="名称" prop="name">
            <Input v-model="expertModel.name" placeholder="输入名称" />
          </FormItem>
          <FormItem label="类型" prop="type">
            <Select v-model="expertModel.type" filterable>
              <Option v-for="(tp,idx) in $common.getEnumSelect($common.expertType)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
            </Select>
          </FormItem>
          <FormItem label="注册执业证书号" prop="registeredNo">
            <Input v-model="expertModel.registeredNo" placeholder="输入注册执业证书号" />
          </FormItem>
          <FormItem label="注册级别" prop="registeredLevel">
            <Select v-model="expertModel.registeredLevel" filterable style="width:200px">
              <Option value="">无</Option>
              <Option value="一级">一级</Option>
              <Option value="二级">二级</Option>
              <Option value="三级">三级</Option>
            </Select>
          </FormItem>
          <FormItem label="电子邮件" prop="email">
            <Input v-model="expertModel.email" placeholder="输入电子邮件" />
          </FormItem>
          <FormItem label="联系人电话" prop="contactTel">
            <Input v-model="expertModel.contactTel" placeholder="输入联系人电话" />
          </FormItem>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
      </i-col>
    </Row>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'expert-new',
  props: {
  },
  data () {
    return {
      loading: false,
      expertModel: {
        name: null,
        type: null,
        registeredNo: null,
        registeredLevel: null,
        contactTel: null,
        email: null
      },
      modelValidate: {
        name: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        registeredNo: [
          { required: true, message: '请填写注册执业证书号', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    async submit () {
      this.$refs.newForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          await Api.Expert.addExpert(this.expertModel)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('新增成功!')
              this.expertModel= {
                name: null,
                type: null,
                registeredNo: null,
                registeredLevel: null,
                contactTel: null,
                email: null
              }
              this.loading = false
              this.$Spin.hide()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    }
  }
}
</script>

<style lang="less">
</style>
